/**
 * @file about
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import { Footer } from '../../components/basic'
import TimeTree from './components/TimeTree'
import { withTranslation } from 'react-i18next';

import './index.scss'

@withTranslation()

class About extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let { t } = this.props;
    let teamList = [
      {
        title: t('about:team_item1_title'),
        content: t('about:team_item1_intro'),
      },
      {
        title: t('about:team_item2_title'),
        content: t('about:team_item2_intro'),
      },
      {
        title: t('about:team_item3_title'),
        content: t('about:team_item3_intro'),
      },
      {
        title: t('about:team_item4_title'),
        content: t('about:team_item4_intro'),
      },
      {
        title: t('about:team_item5_title'),
        content: t('about:team_item5_intro'),
      },
      {
        title: t('about:team_item6_title'),
        content: t('about:team_item6_intro'),
      },
    ],
      content = [
        {
          introduceTitle: t('about:team_item1_title'),
          introduceList: [
            t('about:class_part1'),
            t('about:class_part2'),
            t('about:class_part3'),
          ],
        },
      ]
    return (
      <div>
        <div className="about">
          <div className="banner">
            <p>让每一个中文学习者，都能体会到学习中文的乐趣</p>
            <p>线上实时互动教学平台，让孩子在家自在学习</p>
          </div>
          <div className="inner-title">{content[0].introduceTitle}</div>
          <div className="introduce">
            {content[0].introduceList.map((item, index) => (
              <p key={'introduceList' + index}>{item}</p>
            ))}
          </div>
          <div className="inner-title">{t('about:speak')}</div>
          <div className="address">
            <div className="address-img"></div>
            <div className="address-content">
              <div className="address-title">{t('about:speak')}</div>
              <p className="address-text">
                {t('about:speak_text')}
              </p>
            </div>
          </div>
          <div className="mission">
            <div className="inner-title" style={{ color: '#fff' }}>
              {t('about:taget')}
            </div>
            <p className="mission-text">{t('about:taget_text')}</p>
          </div>
          <div className="inner-title">{t('about:team')}</div>
          <div className="team">
            <ul className="team-ul">
              {teamList.map((item, index) => (
                <li key={'team-' + index} className="team-list">
                  <div className="team-title">{item.title}</div>
                  <div className="team-img"></div>
                  <div className="team-content">{item.content}</div>
                </li>
              ))}
            </ul>
            <div className="team-layout">
              <div className="team-left">
                <div className="team-left-vedio"></div>
              </div>
              <div className="team-right">
                <div className="team-right-vedio"></div>
              </div>
            </div>
          </div>
          <div className="inner-title" style={{ marginBottom: '20px' }}>
            {t('about:intro')}
          </div>
          <span className="inner-title-sub">{t('about:intro_sub')}</span>
          <div className="history">
            <TimeTree />
          </div>
          <div className="news">
            <div className="inner-title">{t('about:news')}</div>
            <ul className="news-ul">
              <li>
                <a>哈兔中文年会盛典| 攻城略地，只争朝夕！</a>
              </li>
              <li>
                <a>中文为桥，联通世界——哈兔中文节暨七周年庆典活动盛大开幕</a>
              </li>
              <li>
                <a>
                  【快讯】哈兔中文与印尼航标国际战略合作签约仪式在哈兔总部举行
                </a>
              </li>
              <li>
                <a>
                  浙江中华文化学院中华文化网络学院举行开播式，首播在线学员达1.2万人
                </a>
              </li>
              <li>
                <a>
                  【快讯】浙江中华文化学院与哈兔中文网络学院举行合作开展网络办学签约仪式
                </a>
              </li>
            </ul>
            <div className="more">
              <a>{t('about:news_more')}</a>
            </div>
          </div>
          <div className="previews">
            <img src="//cdn.ihatoo.com/hatu-official/about/previews.png" />
            <div className="previews-btn">{t('about:news_btn')}</div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default About
